module.exports = __webpack_public_path__ + "img/icon_video.4d5b317a.svg";